__turbopack_context__.v({
  "blockCTAGroup": "BlockCTAGroup-module-scss-module__5z05Bq__blockCTAGroup",
  "buttons": "BlockCTAGroup-module-scss-module__5z05Bq__buttons",
  "copy": "BlockCTAGroup-module-scss-module__5z05Bq__copy",
  "eyebrow": "BlockCTAGroup-module-scss-module__5z05Bq__eyebrow",
  "flushTop": "BlockCTAGroup-module-scss-module__5z05Bq__flushTop",
  "inner": "BlockCTAGroup-module-scss-module__5z05Bq__inner",
});
